import {
  Breadcrumbs,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Link,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { HowToReg, NewReleases, PersonAdd } from "@material-ui/icons";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import BadgeLink from "../../../Components/BadgeLink";
import CountryFlag from "../../../Components/CountrySearch/CountryFlag";
import DialogAppBar from "../../../Components/DialogAppBar";
import SortableTable from "../../../Components/SortableTable";
import TicketEntry from "../../../Components/TicketEntry";
import Title from "../../../Components/Title";
import {
  ECABIN,
  formatTimeWithTZOffset,
  getToken,
  requestErrorHandler,
  TICKET_PRIORITIES,
  ticketListRowStyle,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";
const server = EnvSettings.server;

function TicketListDialog({
  filteredList,
  onClose,
  handleRowClick,
  handleScrollClick,
  header,
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={!!filteredList} fullScreen>
      <DialogContent>
        <DialogAppBar header={header} onClose={onClose} />
        <Grid item xs={12} style={{ marginTop: 80 }}>
          {filteredList ? (
            <SortableTable
              tableLayout={"fixed"}
              headCells={[
                {
                  id: "attachments",
                  hideFromCsv: true,
                  width: 32,
                  label: "",
                },
                {
                  id: "expenses",
                  hideFromCsv: true,
                  width: 32,
                  label: "",
                },
                {
                  id: "Device.serialNumber",
                  numeric: false,
                  disablePadding: false,
                  label: t("serialNumber"),
                },
                {
                  id: "Device.Company.name",
                  label: t("contact"),
                },
                {
                  id: "priority",
                  label: t("ticketList.priority"),
                },
                {
                  id: "summary",
                  numeric: false,
                  disablePadding: false,
                  label: t("ticketList.summary"),
                },
                {
                  id: "description",
                  numeric: false,
                  disablePadding: false,
                  label: t("ticketList.description"),
                },
                {
                  id: "updatedAt",
                  numeric: false,
                  disablePadding: false,
                  label: t("updatedAt"),
                },
              ]}
              getRowStyle={ticketListRowStyle}
              defaultSortRow={"updatedAt"}
              handleRowClick={handleRowClick}
              handleScrollClick={handleScrollClick}
              maxDataLength={30}
              tableData={filteredList}
              rowsPerPage={25}
              downloadButton={true}
              header={t("deviceDetails.maintenanceTickets")}
              specialDataFormatting={[
                {
                  id: "attachments",
                  format: (data) => {
                    return data ? (
                      <Tooltip title={"This ticket has attached media"}>
                        <AttachFileIcon
                          color="primary"
                          style={{ fontSize: 20 }}
                        />
                      </Tooltip>
                    ) : (
                      ""
                    );
                  },
                },
                {
                  id: "Device.Company.name",
                  formatReturnsElement: true,
                  format: (data, d, dd) => {
                    if (data) {
                      return (
                        <>
                          <Typography style={{ fontSize: 14 }}>
                            <CountryFlag
                              country_name={dd.Device.Company.location}
                            />

                            {dd.Device.Company.name}
                          </Typography>
                        </>
                      );
                    }
                    if (dd.Company) {
                      return (
                        <>
                          <Typography style={{ fontSize: 14 }}>
                            <CountryFlag country_name={dd.Company.location} />

                            {dd.Company.name}
                          </Typography>
                        </>
                      );
                    }
                    if (dd.Contact) {
                      return (
                        dd.Contact.name ||
                        Object.values(dd.Contact.additionalInfo)[0]
                      );
                    }
                  },
                },

                {
                  id: "priority",
                  format: (data) => {
                    return Object.keys(TICKET_PRIORITIES).find(
                      (f) => TICKET_PRIORITIES[f] === data
                    );
                  },
                },
                {
                  id: "expenses",
                  format: (data) => {
                    return data ? (
                      <Tooltip title={"This ticket has expenses"}>
                        <AttachMoneyIcon
                          color="primary"
                          style={{ fontSize: 20 }}
                        />
                      </Tooltip>
                    ) : (
                      ""
                    );
                  },
                },
                {
                  id: "state",
                  format: (data) => {
                    return t("ticketList." + data);
                  },
                },
                {
                  id: "updatedAt",
                  format: (data) => {
                    return formatTimeWithTZOffset(data, ECABIN);
                  },
                },
              ]}
            />
          ) : (
            <CircularProgress />
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default function MaintenanceTickets(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [showTicketEntry, setShowTicketEntry] = useState(false);
  const [refreshList, setRefreshList] = useState("dsfsdfds");
  const [selectedTicket, setSelectedTicket] = useState();
  const [filteredList, setFilteredList] = useState();
  const [showUnprioritised, setShowUnprioritised] = useState(false);
  const [showUnassigned, setShowUnassigned] = useState(false);
  const [showAssigned, setShowAssigned] = useState(false);
  const history = useHistory();

  const dispatch = useDispatch();

  let handleRowClick = (data) => {
    if (data) {
      setSelectedTicket(data);
      setShowTicketEntry(true);
    }
  };

  useEffect(() => {
    setFilteredList();
    const getTickets = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          not_states: ["resolved", "stale"],
        }),
      };
      fetch(server + "/get_tickets", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          requestErrorHandler(result, dispatch);
          if (!result.error) {
            if (result.tickets.length !== 0) {
              setFilteredList(result.tickets);
            }
          }
        });
    };
    getTickets();
  }, [dispatch, refreshList]);

  const checkForList = (header) => {
    if (!filteredList) {
      return;
    }
    if (showUnprioritised) {
      if (header) {
        return t("ticketList.unprioritised");
      }
      return filteredList.filter((f) => !f.priority);
    }
    if (showUnassigned) {
      if (header) {
        return t("ticketList.unassigned");
      }
      return filteredList.filter((f) => f.priority && !f.AssigneeId);
    }
    if (showAssigned) {
      if (header) {
        return t("ticketList.assigned");
      }
      return filteredList.filter((f) => f.priority && f.AssigneeId);
    }
  };

  return (
    <Grid container spacing={3}>
      <TicketEntry
        showTicketEntry={showTicketEntry}
        setShowTicketEntry={setShowTicketEntry}
        selectedTicket={selectedTicket}
        setSelectedTicket={setSelectedTicket}
        showHeader={true}
        showSearch={true}
        setRefreshList={setRefreshList}
      />
      <TicketListDialog
        filteredList={checkForList()}
        onClose={() => {
          setShowUnprioritised(false);
          setShowAssigned(false);
          setShowUnassigned(false);
        }}
        handleRowClick={handleRowClick}
        header={checkForList("header")}
      />
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/cpanel/maintenance");
            }}
          >
            {t("maintenance.header")}
          </Link>
          <Typography>{t("maintenance.activeTickets")}</Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  setSelectedTicket();
                  setShowTicketEntry(true);
                }}
              >
                {t("newTicket")} +
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12}>
              <Title>{t("maintenance.activeTickets")}</Title>
            </Grid>
            <Grid item container xs={12} spacing={1}>
              <BadgeLink
                onClick={() => {
                  setShowUnprioritised((e) => !e);
                }}
                icon={NewReleases}
                title={
                  <>
                    {" "}
                    <Typography
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {t("ticketList.unprioritised")}
                    </Typography>
                    <Typography
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {filteredList &&
                        filteredList.filter((f) => !f.priority).length}
                    </Typography>
                  </>
                }
                style={{
                  backgroundColor: "red",
                  color: "white",
                }}
              />

              <BadgeLink
                onClick={() => {
                  setShowUnassigned((e) => !e);
                }}
                style={{ backgroundColor: "yellow" }}
                icon={PersonAdd}
                title={
                  <>
                    {" "}
                    <Typography
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {t("ticketList.unassigned")}
                    </Typography>
                    <Typography
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {filteredList &&
                        filteredList.filter((f) => f.priority && !f.AssigneeId)
                          .length}
                    </Typography>
                  </>
                }
              />

              <BadgeLink
                onClick={() => {
                  setShowAssigned((e) => !e);
                }}
                style={{ backgroundColor: "#3d57a5", color: "white" }}
                icon={HowToReg}
                title={
                  <>
                    {" "}
                    <Typography
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {t("ticketList.assigned")}
                    </Typography>
                    <Typography
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      {filteredList &&
                        filteredList.filter((f) => f.priority && f.AssigneeId)
                          .length}
                    </Typography>
                  </>
                }
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
